<template>
  <div>
  </div>
</template>

<script>
import useAuth from "@/useAuth";
import { onMounted } from "@vue/composition-api";
import { useRouter } from "@/@core/utils";

export default {
  setup() {
    // const { isAuthenticated, token, user, tenant } = useAuth();

    const { router } = useRouter();

    onMounted(() => {
      router.replace({ name: "admin-news-list" });
    });

    return {
      // isAuthenticated,
      // token,
      // tenant,
      // user,
    };
  },
};
</script>
